import React, { useMemo, useState } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import ButtonWrapper from '../../ButtonWrapper';
import splitListItems from '../../../helpers/splitListItems';

import './style.scss';

const MAX_PARTNERS_SHOWN_BY_DEFAULT = 3;

export interface Partner {
  name: string;
  url: string;
}

export interface PartnersWidgetProps {
  partners: Partner[];
  className?: string;
}

const PartnersWidget: React.FC<PartnersWidgetProps> = (props) => {
  const { partners, className } = props;

  const { t } = useTranslation('translation', { keyPrefix: 'components.widgets.partners_widget' });

  const [isExpanded, setExpanded] = useState(false);
  const [initialPartners, additionalPartners] = useMemo(() => (
    splitListItems<Partner>(partners, MAX_PARTNERS_SHOWN_BY_DEFAULT)
  ), [partners]);

  const classes = c('PartnersWidget', 'Paper', className, {
    'PartnersWidget--expanded': isExpanded,
  });

  return (
    <div className={classes}>
      <h2 className="PartnersWidget__title asH3">
        {t('title', { count: partners.length })}
      </h2>

      {(initialPartners && initialPartners.length > 0) && (
        <ul className="PartnersWidget__list PartnersWidget__list--initial-group">
          {initialPartners.map((partner) => (
            <li key={`partner-${partner.url}`} className="body--small">
              {partner.url.match('nolink') ? (
                partner.name
              ) : (
                <ButtonWrapper type="textual" href={partner.url}>{partner.name}</ButtonWrapper>
              )}
            </li>
          ))}
        </ul>
      )}

      {(additionalPartners && additionalPartners.length > 0) && (
        <>
          <div className="PartnersWidget__list-wrapper">
            <ul className="PartnersWidget__list PartnersWidget__list--additional-group">
              {additionalPartners.map((partner) => (
                <li key={`partner-${partner.url}`} className="body--small">
                  {partner.url === 'route:<nolink>' ? (
                    partner.name
                  ) : (
                    <ButtonWrapper type="textual" href={partner.url}>{partner.name}</ButtonWrapper>
                  )}
                </li>
              ))}
            </ul>
          </div>

          <ButtonWrapper
            className="PartnersWidget__show-more-button"
            type="textual"
            iconName="keyboard_arrow_down"
            iconPosition="left"
            onClick={() => setExpanded(!isExpanded)}
          >
            {t(isExpanded ? 'show_less_button' : 'show_more_button')}
          </ButtonWrapper>
        </>
      )}
    </div>
  );
};

export default PartnersWidget;
